import { useEffect, useState } from 'react';
import { Collapse } from 'antd';
import { useParams } from "react-router-dom";
import { EventService } from '../../Services/EventService';
import 'react-multi-email/dist/style.css';
import { AuthProvider } from '../../Providers/authProvider';
import { InviteService } from '../../Services/InviteService';
import { ReminderForm } from '../../Components/EventDetails/ReminderForm';
import { TextService } from '../../Services/TextService';
import LayoutLeftMenu from '../../Components/Layout/LayoutLeftMenu';
import LeftMenuEventDetails from './LeftMenuEventDetails';
import { AuthenticatedUser } from '../../Types/AuthenticatedUser';

const MyEventDetailsReminder = () => {
  const [event, setEvent] = useState([] as any);
  const [invites, setInvites] = useState([] as any);
  const [invitesNoReply, setInvitesNoReply] = useState<string[]>([]);
  const GetText = TextService.GetText;
  const [user, setUser] = useState({} as AuthenticatedUser | null);

  let params = useParams();
  const { Panel } = Collapse;

  const loadInvites = (eventUniqueId: string) => {
    InviteService.GetInvites(eventUniqueId).then(inviteResult => {
      setInvites(inviteResult.invites);

      let noReplies: string[] = [];
      inviteResult.invites?.forEach((invite: any) => {
        if (invite.replyId == 0) {
          noReplies.push(invite.email);
        }
      });

      setInvitesNoReply(noReplies);

    });
  }

  const loadEvent = (id: string) => {
    EventService.GetEventDetails(id).then(result => {
      setEvent(result);
      loadInvites(result.eventUniqueId ? result.eventUniqueId : "");
    });
  };

  useEffect(() => {

    AuthProvider().GetLoggedInUser().then(user => {
      setUser(user);
    });

    AuthProvider().ValidateUserLogin();
    if (params.id != null) {
      loadEvent(params.id);
    }
  }, [params])


  return (
    <LayoutLeftMenu hasTitleTop={true} titleTop={event.eventName} title={GetText("MyEventDetails_Reminders")} fullpageMain={false} menu={<LeftMenuEventDetails selected={"myeventreminders"} />}>
    </LayoutLeftMenu>);
};

export default MyEventDetailsReminder;